import React, { useEffect } from 'react';
import { AppRegistry } from "react-native-web";
import { Button, StyleSheet, Text, View, Dimensions } from 'react-native-web';
import Screen from './Screen';
function Link(props) {
  return <Text {...props} accessibilityRole="link" style={StyleSheet.compose(styles.link, props.style)} />;
}
let ScreenHeight = Dimensions.get('window').height;
let DWidth=Math.floor(ScreenHeight*8.25/16)
function App() {
  document.getElementById("root").style.backgroundColor="black"
  return (
    <div  style={{backgroundColor:"black",height:"100vh",maxHeight:"100vh",width:"100vw",display:"flex",justifyContent:"center"}}>
   <div style={{backgroundColor:"black",borderRadius:12,marginTop:ScreenHeight*0.01,border:"1px solid gray",height:ScreenHeight*.95,maxHeight:ScreenHeight*.95,width:DWidth,maxWidth:DWidth,overflow:"hidden",display:"flex",flexDirection:"row",justifyContent:"center"}}>
  
    <Screen/>
   </div>
   </div>
  // 
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: ScreenHeight,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5FCFF'
  },
  header: {
    padding: 20
  },
  title: {
    fontWeight: 'bold',
    fontSize: '1.5rem',
    marginVertical: '1em',
    textAlign: 'center'
  },
  text: {
    lineHeight: '1.5em',
    fontSize: '1.125rem',
    marginVertical: '1em',
    textAlign: 'center'
  },
  link: {
    color: '#1B95E0'
  },
  code: {
    fontFamily: 'monospace, monospace'
  }
});
//@ts-ignore


window.addEventListener("resize",()=>{

  window.location.reload()
})
AppRegistry.registerComponent("App", () => App);


export default function AMode(){
  useEffect(()=>{
    AppRegistry.runApplication("App", {
      rootTag: document.getElementById("inroot")
    });
  },[])
return (<div id="inroot" />)
}

